import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';
import type { UIGenericDialogOptions } from '../../../ui/UIManager';
import { UI } from '../../../ui/UIManager';
import type { PostInputProps } from './PostInput';
import { PostInput } from './PostInput';

export type PostInputModalProps = {
  inkindRouteId: string;
};

export function openPostInputModal(
  { inkindRouteId }: PostInputModalProps,
  inputProps: Partial<PostInputProps>,
  options: UIGenericDialogOptions
) {
  const buttonsRef = React.createRef<HTMLDivElement>();
  const bem = bemBlock('post-input-modal');

  UI.dialog(
    ({ close, footerRef }) => (
      <PostInput
        inkindRouteId={inkindRouteId}
        buttonsPortal={footerRef}
        {...inputProps}
        onSubmit={payload => {
          inputProps.onSubmit?.(payload, close);
          // close(false);
        }}
        buttonsRef={buttonsRef}
      />
    ),
    {
      // TODO: translation do not seem to work here
      title: 'Leave a Message',
      closable: true,
      className: bem(),
      autowidth: false,
      padding: true,
      footer: <div className={bem('footer')} ref={buttonsRef} />,
      ...options,
    }
  );
}
